const projects = [
  {
    title: 'AR Hewan dan Transportasi',
    tech: 'Vuforia, Unity',
    role: 'Fullstack',
    image: './AR-1.png',
  },
  {
    title: 'BMKG CEWS',
    tech: 'Laravel, JQuery',
    role: 'Fullstack',
    image: './BMKG-2.jpeg',
  },
  {
    title: 'Koperasi Berkat Sushi Tei',
    tech: 'Laravel, ReactJs',
    role: 'Fullstack',
    image: './Koperasi-1.png',
  },
  {
    title: 'Condition Based Maintenance',
    tech: 'Dotnet, ReactJs, Single SPA, Redux',
    role: 'Frontend',
    image: './CBM-2.png',
  },
  {
    title: 'Maintenance Strategy Reference',
    tech: 'Dotnet, ReactJs, Single SPA, Redux',
    role: 'Frontend',
    image: './MSR-1.png',
  },
];

export default projects;
